// SubscriptionForm.js
import { useState } from 'react';

export default function SubscriptionForm() {
  const [inputValue, setInputValue] = useState('');

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`Submitted: ${inputValue}`);
  };

  return (
    <div className="container subscription-section">
      <div className="subscription-info">
        <p className="subscription-text">Receive valuable insights directly in your email inbox.</p>
        <p className="privacy-policy-text">By providing my details, I consent to the privacy policy and wish to discover more about the products and services offered by Belsoft Systems.</p>
      </div>
      <div className="input-container">
        <input
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          placeholder="Enter Email Here..."
          className="input-field"
        />
        <button
          onClick={handleSubmit}
          className="subscribe-button"
        >
          Subscribe
        </button>
      </div>
    </div>
  );
}
